import { Box, Container, Typography } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import { getToken } from "../../redux/selector";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";

function HealthCheck() {
    const { t, i18n } = useTranslation();
    const gettoken = useSelector(getToken());
    const dispatch = useDispatch();
    const [result,setResult] = useState({});
    const useStyles = makeStyles({
        tablecellFailed:{
          textAlign:"center",
          color: "red"
        },
        tablecellPassed:{
          textAlign:"center",
          color: "#03c81e"
        },
    });
    const classes = useStyles();
    useEffect(()=>{
      const option = {
      url: `${Config.CONTENT_PATH}/connectionHealthCheck`
      };
      dispatch(send("HEALTH_CHECK", option))
          .then((response) => {return response.json()})
          .then(data=>{
            console.log(data)
            setResult(data)
          }
          );
    },[])
    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.portal.Home")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main className="main">
                  <div style={{display: "flex",justifyContent: 'center',alignItems: 'center',}}>
                    <Box style={{width: "80%", justifyContent: "center",alignItems: "center"}}>
                      <Typography variant="h6">{t("common.portal.HealthCheck")}:</Typography>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead style={{background: "#bbb"}}>
                            <TableRow>
                              <TableCell style={{fontWeight:"bold", width:"40%"}}>Data</TableCell>
                              <TableCell style={{fontWeight:"bold", width:"30%", textAlign:"center"}}>Connection</TableCell>
                              <TableCell style={{fontWeight:"bold", width:"30%", textAlign:"center"}}>Last Update</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody style={{background: "#eee"}}>
                            <TableRow>
                              <TableCell style={{fontWeight:"bold"}}>EDIS</TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          </TableBody>
                          <TableBody>
                            <TableRow>
                              <TableCell>Staff</TableCell>
                              <TableCell className={result?.edis?.staff==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.edis!=null && (result?.edis?.staff==true?"Passed":"Failed")}</TableCell>
                              <TableCell className={result?.lastUpdate?.EDISUpdate==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.lastUpdate!=null && (result?.lastUpdate?.EDISUpdate ? "Passed":"Failed")}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>School</TableCell>
                              <TableCell className={result?.edis?.school==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.edis!=null && (result?.edis?.school==true?"Passed":"Failed")}</TableCell>
                              <TableCell className={result?.lastUpdate?.EDISUpdate==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.lastUpdate!=null && (result?.lastUpdate?.EDISUpdate ? "Passed":"Failed")}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Premise</TableCell>
                              <TableCell className={result?.edis?.premise==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.edis!=null && (result?.edis?.premise==true?"Passed":"Failed")}</TableCell>
                              <TableCell className={result?.lastUpdate?.EDISUpdate==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.lastUpdate!=null && (result?.lastUpdate?.EDISSCPUpdate ? "Passed":"Failed")}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Premise Info</TableCell>
                              <TableCell className={result?.edis?.premiseInfo==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.edis!=null && (result?.edis?.premiseInfo==true?"Passed":"Failed")}</TableCell>
                              <TableCell className={result?.lastUpdate?.EDISUpdate==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.lastUpdate!=null && (result?.lastUpdate?.EDISSCPUpdate ? "Passed":"Failed")}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <br/>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{fontWeight:"bold", width:"40%"}}>CLO</TableCell>
                              <TableCell style={{width:"30%", textAlign:"center"}} className={result.clo==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.clo!=null && (result.clo==true?"Passed":"Failed")}</TableCell>
                              <TableCell style={{width:"30%", textAlign:"center"}} className={result?.lastUpdate?.CLOUpdate==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.lastUpdate!=null && (result?.lastUpdate?.CLOUpdate ? "Passed":"Failed")}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <br/>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{fontWeight:"bold",width:"40%"}}>TCS</TableCell>
                              <TableCell style={{width:"30%", textAlign:"center"}} className={result.tcs==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.tcs!=null && (result.tcs==true?"Passed":"Failed")}</TableCell>
                              <TableCell style={{width:"30%", textAlign:"center"}} className={result?.lastUpdate?.TCSUpdate==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.lastUpdate!=null && (result?.lastUpdate?.TCSUpdate ? "Passed":"Failed")}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <br/>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{fontWeight:"bold", width:"40%"}}>ADFS</TableCell>
                              <TableCell style={{width:"30%", textAlign:"center"}} className={result.adfs==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.adfs!=null && (result.adfs==true?"Passed":"Failed")}</TableCell>
                              <TableCell style={{width:"30%", textAlign:"center"}} className={classes.tablecellPassed}>{"N/A"}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          </TableBody>
                        </Table>
                        </TableContainer>
                        <br/>
                      {/*  <TableContainer component={Paper}>*/}
                      {/*  <Table>*/}
                      {/*    <TableHead>*/}
                      {/*      <TableRow>*/}
                      {/*        <TableCell style={{fontWeight:"bold", width:"40%"}}>REO Personnel</TableCell>*/}
                      {/*        <TableCell style={{width:"30%", textAlign:"center"}} className={classes.tablecellPassed}>{"N/A"}</TableCell>*/}
                      {/*        <TableCell style={{width:"30%", textAlign:"center"}} className={result?.lastUpdate?.ReoPersonnelUpdate==true?classes.tablecellPassed:classes.tablecellFailed}>{result?.lastUpdate!=null && (result?.lastUpdate?.ReoPersonnelUpdate ? "Passed":"Failed")}</TableCell>*/}
                      {/*      </TableRow>*/}
                      {/*    </TableHead>*/}
                      {/*    <TableBody>*/}
                      {/*    </TableBody>*/}
                      {/*  </Table>*/}
                      {/*</TableContainer>*/}
                      {/*<br/>*/}
                    </Box>
                  </div>
                </main>
            </Box>
        </Container>
    );
}
export default HealthCheck;